import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgbProgressbarModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { DataTablesModule, DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { CommonService } from '../../../Model/Common/common.service';
import { EmployeeRegistrationService } from '../../../Model/EmployeeRegistration/employee-registration.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';

@Component({
  selector: 'app-candidate-initiation',
  standalone: true,
  imports: [CommonModule, RouterModule, DataTablesModule, NgbProgressbarModule, FormsModule, NgbDropdownModule, LoaderComponent],
  templateUrl: './candidate-initiation.component.html',
  styleUrl: './candidate-initiation.component.scss'
})
export class CandidateInitiationComponent {
  isDisabled: boolean = false;
  stars = [0, 1, 2, 3, 4] as any;
  user = [] as any;
  EmployeeData = [] as any;
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    TabName: null as any,
    IsDaft: true,
    ListType: 1,
    EmpType: null as any,
  }
  dtoptions: DataTables.Settings = {};
  constructor(
    private employeeRegistration: EmployeeRegistrationService,
    protected common: CommonService,
    private tooltip: TooltipService,
    private session: SessionService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.Filter.EmpType = this.router.url.split('/')[3];
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_PreOnBoardingSelect();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_PreOnBoardingSelect() {
    this.isDisabled = true;
    if (this.Filter.ListType == 1) {
      this.Filter.TabName = 'Initiate';
    } else if (this.Filter.ListType == 2) {
      this.Filter.TabName = 'LoggedIn';
    }
    this.employeeRegistration.ESS_PreOnBoardingSelect({ 'SelectType': this.Filter.TabName, 'EmpMasterId': 0, 'By': this.user.UserId, 'EmpType': this.Filter.EmpType }).subscribe({
      next: (response) => {
        this.EmployeeData = Object.values(response.Table)
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  setSelectType(type: number) {
    this.EmployeeData = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.Filter.ListType = type;
    this.ESS_PreOnBoardingSelect();
  }

  ESS_SendReminderMailSend(id: string) {
    if (id == '0') {
      id = this.EmployeeData.filter((e: any) => e.IsARCheck).map((e: any) => e.EmpMasterId).toString();
    }
    if (id != undefined && id != null && id != '') {
      this.isDisabled = true;
      this.employeeRegistration.ESS_SendReminderMailSend({ 'SelectType': 'PreOnBoarding', 'EmpMasterId': id, 'By': this.user.UserId, Domain: this.user.Domain, AppLink: document.location.protocol + '//' + window.location.hostname }).subscribe({
        next: (response) => {
          if (response.Error_Code == '01') {
            id = this.EmployeeData.map((e: any) => e.IsARCheck = false);
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.success });
          } else {
            this.toast.show({ message: response.Error_Message, type: toastTypeEnum.warning });
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } else {
      this.toast.show({ message: "Please select candidate", type: toastTypeEnum.warning });
    }
  }

  ARCheck(event: any, i: number, IsAll = false) {
    if (IsAll) {
      this.EmployeeData.map((e: any) => e.IsARCheck = event.target.checked);
    } else {
      this.EmployeeData[i].IsARCheck = event.target.checked;
    }
  }
}
